import { render, staticRenderFns } from "./ForwardsMX.vue?vue&type=template&id=07b88a32&scoped=true"
import script from "./ForwardsMX.vue?vue&type=script&lang=js"
export * from "./ForwardsMX.vue?vue&type=script&lang=js"
import style0 from "./ForwardsMX.vue?vue&type=style&index=0&id=07b88a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b88a32",
  null
  
)

export default component.exports